function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHorizontalPoints = function SvgHorizontalPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.332 15.879a3.614 3.614 0 1 1-7.228 0 3.614 3.614 0 0 1 7.228 0zm9.034 3.614a3.614 3.614 0 1 0 0-7.228 3.614 3.614 0 0 0 0 7.228zm12.649 0a3.614 3.614 0 1 0 0-7.228 3.614 3.614 0 0 0 0 7.228z",
    style: {
      strokeWidth: 1.97116
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "9.33333px",
      lineHeight: 1.25,
      fontFamily: "sans-serif"
    },
    x: 5.046,
    y: 39.042
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.046,
    y: 39.042,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "9.33333px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "MORE")));
};
export default SvgHorizontalPoints;